import { render } from "./HelloWorld.vue?vue&type=template&id=a5563d4e&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=a5563d4e&scoped=true&lang=css"

import exportComponent from "/Users/isamu/ss/misc-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5563d4e"]])

export default __exports__